module.exports = __webpack_public_path__ + "img/data.18d26fe0.jpg";